<template>
  <div class="component-container">
    <div class="footer-container flex flex-dr flex-center">
      <div class="flex flex-start top">
        <img :src="infoManage.logos.pc_logo_bottom" alt="" class="logo">
        <span v-if="infoManage.qqList.length>0">QQ：<b v-for="qq in infoManage.qqList" style="font-weight: normal;margin-right: 10px">{{qq.value}}</b></span>
        <span>电话：<b  style="font-weight: normal;margin-right: 10px">028-61551840</b></span>
      </div>
      <div class="navs">
        <div class="nav-box flex flex-center">
          <a href="/product" style="margin-right: 100px">党史学习资源</a>
          <a href="/?hash=about">关于{{ infoManage.companyNameShort }}</a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {ConfigModel} from "@/model/erp/ConfigModel";
import {findObjectArrSameItemForArr} from "@/utils/common"

export default {
  name: "footer54",
  data() {
    return {
      infoManage: {
        logos: {},
        contactObj: {},
        qqList: [],
        phoneList: []
      }
    }
  },
  async mounted() {
    let indexManage = await ConfigModel.getIndexConfig();
    indexManage.infoManage.qqList= findObjectArrSameItemForArr(indexManage.infoManage.contactList, "type", "qq")
    indexManage.infoManage.phoneList= findObjectArrSameItemForArr(indexManage.infoManage.contactList, "type", "phone")
    this.infoManage = indexManage.infoManage
    if (this.$route.query.hash) {
      setTimeout(() => {
        location.hash = this.$route.query.hash
      }, 350)
    }
  }
}
</script>

<style scoped lang="less">
.footer-container {
  color: rgba(255, 255, 255, 0.5);
  font-size: 14px;
  padding:20px 0px;
  border: 1px solid #707070;

  .top {
    margin-bottom: 30px;

    .logo {
      width: 197px;
      height: 18px;
      display: inline-block;
    }

    span {
      display: inline-block;
      margin-left: 32px;
    }
  }


  .navs {
    width: 100%;
    border: 1px solid rgba(228, 228, 228, 0.15);
    border-right: none;
    border-left: none;
    border-bottom: none;
    height: 55px;
    padding-top: 10px;

    .nav-box {
      width: 1000px;
      margin: 0 auto;

      a {
        text-decoration: none;
        font-weight: 400;
        color: #fff;
        line-height: 55px;
      }
    }
  }

  .address {
    margin-top: 20px;
  }

  .copyright {
    margin-top: 8px;
  }
}
</style>
